import React from 'react';

import svg from './assets/icons-32-shopping-bag.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

/** @deprecated Use the Icon component from the design-system-core-components package. */
export const IconBasketSolid = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-basket-solid" />
);
